import { useState, useRef } from 'react'
//Language
import Translate from '../i18n/Translate'
//Hooks
import useScrollTop from '../hooks/useScrollTop'
import useSetI18nProviderInformation from '../hooks/useSetI18nProviderInformation'
//Components
import ShortArrow from '../components/svg/ShortArrow'
import OperatorsGallery from '../components/OperatorsGallery'
//Containers
import Testimonials from '../containers/Home/Testimonials'
import PackagesDestacados from '../containers/Home/PackagesDestacados'
import Services from '../containers/Home/Services'
import GoFAQs from '../containers/Home/GoFAQs'
import DestinationSearch from '../components/DestinationSearch'

const Home = () => {
    useScrollTop()
    useSetI18nProviderInformation('home')

    const [showTitle, setShowTitle] = useState(false)

    const searchRef = useRef()

    const scrollToSearch = () => {
        searchRef.current.style.scrollMarginTop = '40px'
        searchRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <main className="incoming-home">
            {/* SECCION SUPERIOR, TITULO + SELECTOR DE DESTINOS*/}
            <section className="incoming-home__top">
                <h1 className={`title top-title animate slide-title ${showTitle && 'in-view'} `}>
                    <Translate langkey="home.title" />
                </h1>
                <div className={`arrow-wrapper animate show-arrow ${showTitle && 'in-view'}`} onClick={scrollToSearch}>
                    <ShortArrow />
                </div>

                {/* Selector / buscador de destinos */}
                <div className="destination-select-wrapper" ref={searchRef}>
                    <DestinationSearch />
                </div>

                {/* TODO => temporal, acomodar por algo mejor luego */}
                <div className="images-loading-cover" onAnimationEnd={() => setShowTitle(true)}></div>
            </section>

            {/* PAQUETES DESTACADOS */}

            <PackagesDestacados />

            {/* SERVICIOS */}
            <Services />

            {/* TESTIMONIOS */}
            <Testimonials />

            {/* IR A PREGUNTAS FRECUENTES + GALERIA OPERADORES/AGENCIAS */}
            <GoFAQs />

            <OperatorsGallery />
        </main>
    )
}

export default Home
